import React from 'react';
import '../styles/CountdownGauge.css';

const CountdownGauge = ({ totalSeconds, remainingSeconds, phase }) => {
  const circles = Array(totalSeconds).fill(0).map((_, index) => (
    <div
      key={index}
      className={`countdown-circle ${
        index < remainingSeconds && phase === 'countdown' ? 'active' : 'inactive'
      }`}
    />
  ));

  return (
    <div className="countdown-gauge">
      {circles}
    </div>
  );
};

export default CountdownGauge;